import img15a from '../../../assets/gallery/15b/15b-01-HOME_Serie-blanca-1-2015-200x300cm-oleo-sobre-papel.jpg.jpg';
import img15b from '../../../assets/gallery/15b/15b-02_Serie-blanca-2-2015-200x300cm-oleo-sobre-papel.jpg';
import img15c from '../../../assets/gallery/15b/15b-03_Serie-blanca-3-2015-200x300cm-oleo-sobre-papel.jpg';
import img15d from '../../../assets/gallery/15b/15b-05_Serie-blanca-5-2015-200x300cm-oleo-sobre-papel.jpg';
import img15e from '../../../assets/gallery/15b/15b-06_ST-2015-200x300cm-oleo-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15a,
    description: "2015",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15b,
    description: "2015",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15c,
    description: "2015",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15d,
    description: "2015",
    orientation: "h"
  },
  {
    id: 5,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15e,
    description: "2015",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/15b/data15b.js